var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "editBtn" },
    [
      _c(
        "el-dropdown",
        {
          staticClass: "fileFormat",
          attrs: { trigger: "click", placement: "bottom-start" },
          on: { "visible-change": _vm.dropdownClick },
        },
        [
          _c("span", { staticClass: "el-dropdown-link" }, [
            _c("img", {
              attrs: {
                src: require("@/assets/imgs/cloudSpace/hms_arrow.webp"),
                alt: "",
              },
            }),
            _vm._v(_vm._s(_vm.getFileType(_vm.fileType)) + " "),
          ]),
          _c(
            "el-dropdown-menu",
            {
              attrs: { slot: "dropdown", appendToBody: false },
              slot: "dropdown",
            },
            _vm._l(_vm.options.fileFormat, function (item, index) {
              return _c(
                "el-dropdown-item",
                { key: index, on: { click: _vm.dropdownChange } },
                [
                  [
                    _c(
                      "div",
                      {
                        staticClass: "lang-items",
                        on: {
                          click: function ($event) {
                            return _vm.dropdownChange(item.value)
                          },
                        },
                      },
                      [_c("span", [_vm._v(_vm._s(item.lable))])]
                    ),
                  ],
                ],
                2
              )
            }),
            1
          ),
        ],
        1
      ),
      _vm._l(_vm.options.fileEdit, function (item, index) {
        return _c(
          "div",
          {
            key: index,
            staticClass: "filesEdit",
            on: {
              mouseover: function ($event) {
                $event.stopPropagation()
                return _vm.handleMouseOver(index)
              },
              mouseleave: function ($event) {
                $event.stopPropagation()
                return _vm.handleMouseLeave(index)
              },
            },
          },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.hiddenBtn(item),
                    expression: "hiddenBtn(item)",
                  },
                ],
                class: [`${item.value}-icon`, "fileEdit"],
                on: {
                  click: function ($event) {
                    return _vm.handlerClick(item.value)
                  },
                },
              },
              [
                [
                  _c("div", { staticClass: "slot editBtn-slot" }, [
                    _c("img", {
                      staticClass: "editBtn-slot-img",
                      attrs: { src: _vm.getIcon(item, index), alt: "" },
                    }),
                    _c("span", { staticClass: "editBtn-slot-text" }, [
                      _vm._v(_vm._s(item.lable)),
                    ]),
                  ]),
                ],
              ],
              2
            ),
          ],
          1
        )
      }),
      _c(
        "el-radio-group",
        {
          staticClass: "fileView",
          on: {
            change: _vm.fileViewChange,
            mouseleave: function ($event) {
              $event.stopPropagation()
              return _vm.fileViewLeave(_vm.index)
            },
            mouseover: function ($event) {
              $event.stopPropagation()
              return _vm.fileViewOver(_vm.index)
            },
          },
          model: {
            value: _vm.fileViewNew,
            callback: function ($$v) {
              _vm.fileViewNew = $$v
            },
            expression: "fileViewNew",
          },
        },
        _vm._l(_vm.options.fileView, function (item, index) {
          return _c(
            "el-radio-button",
            { key: index, attrs: { label: item.value } },
            [
              _c("img", {
                attrs: {
                  src: require(`@/assets/imgs/cloudSpace/${item.icon}`),
                  alt: "",
                },
              }),
            ]
          )
        }),
        1
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.fileList.length > 0 || _vm.downloadFileList.length > 0,
              expression: "fileList.length > 0 || downloadFileList.length > 0",
            },
          ],
          staticClass: "tips",
        },
        [
          _c("img", {
            attrs: {
              src: require("@/assets/imgs/cloudSpace/information.webp"),
              alt: "",
            },
          }),
          _c("span", [_vm._v(_vm._s(_vm.$t("avoid_refresh_transfer")))]),
        ]
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }